import { EmployeeMain } from "../../models/employeeModel";
import { EmployeeActionTypes } from "../actions/employeeAction";
import InitialState from "./initialState";
import { CandidateBulkUpload } from "./../../models/employeeModel";

const initialState: EmployeeMain = InitialState.employee;
export default function EmployeeReducer(
  state: EmployeeMain = initialState,
  action: any
) {
  switch (action.type) {
    case EmployeeActionTypes.Get_All_Event_Staus_Success_Action:
      return {
        ...state,
        event_list: action.payload.req,
        filter: action.payload.filter,
      };
    case EmployeeActionTypes.Get_All_Refferal_Success_Action:
      return {
        ...state,
        refferal_list: action.payload.list,
        refferal_count: action.payload.count,
      };
    case EmployeeActionTypes.Get_Employee_View_Success_Action:
      return { ...state, employee_detail: action.payload };
    case EmployeeActionTypes.Get_Reporting_Manager_Success_Action:
      return { ...state, ReportingManagerList: action.payload };
    case EmployeeActionTypes.Get_Reporting_Manager_Org_Success_Action:
      return { ...state, reportingManagerOrgList: action.payload };
    case EmployeeActionTypes.Get_Reporting_Manager_Search_Success_Action:
      return { ...state, reportingManagerSearchList: action.payload };
    case EmployeeActionTypes.Get_All_Candidate_Success_Action:
      return {
        ...state,
        candidate_list: action.payload.list,
        candidate_count: action.payload.count,
      };
    case EmployeeActionTypes.Get_Attendence_Salary_type_Success_Action:
      return { ...state, attendence_salary_type: action.payload };
    // case EmployeeActionTypes.GET_All_Employee_WITH_PDF:
    //   return {
    //     ...state,
    //     employee_list: action.payload.list,
    //     employee_count: action.payload.count,
    //     employee_pdf_list: action.payload.pdfList, // this is dataset is for creating employee data pdf
    //   };
    case EmployeeActionTypes.Get_All_Employee_Success_Action:
      return {
        ...state,
        employee_list: action.payload.list,
        employee_count: action.payload.count,
      };
    case EmployeeActionTypes.Get_Action_Status_Success_Action:
      return { ...state, action_event_list: action.payload };
    case EmployeeActionTypes.Get_Employee_All_Details_Success_Action:
      return {
        ...state,
        documents_details: action.payload.documents_details,
        employeeDetails: action.payload.employeeDetails,
        permanent_address: action.payload.permanent_address,
        present_address: action.payload.present_address,
        education_details: action.payload.education_details,
        experience_details: action.payload.experience_details,
        ProjectAssociationWithLevelName:
          action.payload.ProjectAssociationWithLevelName,
        designation_name_with_details:
          action.payload.designation_name_with_details,
        EmployeeAttendanceReport: action.payload.EmployeeAttendanceReport,
        SalaryDetail: action.payload.SalaryDetail,
        SalaryHistory: action.payload.SalaryHistory,
        professional_details: action.payload.professional_details,
        reporting_manager_details: action.payload.reporting_manager_details,
      };
    case EmployeeActionTypes.Get_All_Bank_Success_Action:
      return { ...state, bank_list: action.payload };
    case EmployeeActionTypes.Candidate_Bulk_Upload_List_Success_Action: {
      const sanitizeList = (payload: any): any[] => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        if (payload.data && Array.isArray(payload.data.list)) return payload.data.list;
        if (payload.data && Array.isArray(payload.data)) return payload.data;
        if (Array.isArray(payload.list)) return payload.list;
        if (Array.isArray(payload.rows)) return payload.rows;
        return [];
      };
      return {
        ...state,
        candidateBulkUploadList: sanitizeList(action.payload),
        candidateBulkUploadTotal: action.payload?.total || action.payload?.data?.total || 0,
      };
    }
    case EmployeeActionTypes.GET_BULK_UPLOAD_STATUS_ACTION: {
      const sanitizeList = (payload: any): any[] => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        if (payload.data && Array.isArray(payload.data.list)) return payload.data.list;
        if (payload.data && Array.isArray(payload.data)) return payload.data;
        if (Array.isArray(payload.list)) return payload.list;
        if (Array.isArray(payload.rows)) return payload.rows;
        return [];
      };
      return {
        ...state,
        candidateBulkUploadList: sanitizeList(action.payload),
        candidateBulkUploadTotal: action.payload?.total || action.payload?.data?.total || 0,
      };
    }
    case EmployeeActionTypes.GET_BULK_UPLOAD_STATUS_ACTION_UPDATED: {
      const sanitizeList = (payload: any): any[] => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;
        if (payload.data && Array.isArray(payload.data.list)) return payload.data.list;
        if (payload.data && Array.isArray(payload.data)) return payload.data;
        if (Array.isArray(payload.list)) return payload.list;
        if (Array.isArray(payload.rows)) return payload.rows;
        return [];
      };
      const updatedPayload = sanitizeList(action.payload);
      const payloadIds = updatedPayload.map(
        (self: { bulk_id?: any; upload_id?: any }) => self.bulk_id || self.upload_id
      );
      const currentList = Array.isArray(state.candidateBulkUploadList) ? state.candidateBulkUploadList : [];
      const newData = currentList.filter(
        (self: any) => !payloadIds.includes(self.bulk_id || self.upload_id)
      );

      return {
        ...state,
        candidateBulkUploadList: [...updatedPayload, ...newData],
      };
    }

    case EmployeeActionTypes.Get_My_Team_List_Success_Action:
      return {
        ...state,
        myTeamList: action.payload,
      };

    case EmployeeActionTypes.Get_Employee_Locations_Success_Action:
      return {
        ...state,
        employeeLocationsLists: action.payload,
      };

    case EmployeeActionTypes.Get_Employee_Images_Success_Action:
      return {
        ...state,
        employeeImages: action.payload,
      };

    case EmployeeActionTypes.Get_My_Document_Success_Action:
      return {
        ...state,
        myDocuments: action.payload,
      };

    case EmployeeActionTypes.Change_Reporting_Manager_Success_Action:
      return {
        ...state,
        changeReportingManager: action.payload,
      };
    case EmployeeActionTypes.Calculate_Employee_Single_Salary_Success_Action:
      return {
        ...state,
        calculate_single_emp_salary: action.payload,
      };
    case EmployeeActionTypes.Candidate_List_Against_Status_Success_Action:
      return {
        ...state,
        candidate_list_against_status: action.payload,
      };
    case EmployeeActionTypes.Salary_Given_For_Waiting_Candidate_Success_Action:
      return {
        ...state,
        salary_given_for_cand: action.payload,
      };
    case EmployeeActionTypes.Get_Salary_Details_For_Candidate_Success_Action:
      return {
        ...state,
        salary_details_for_cand: action.payload,
      };
    case EmployeeActionTypes.Get_All_Term_Conditions_Success_Action:
      return {
        ...state,
        get_all_term_conditions: action.payload,
      };
    case EmployeeActionTypes.Employee_Transfer_Success_Action:
      return { ...state };
    case EmployeeActionTypes.Get_Employee_Transfer_Requests_Success_Action: {
      const payloadData = action.payload?.data || action.payload;
      const list = Array.isArray(payloadData) ? payloadData : payloadData?.data || [];
      const pagination = payloadData?.pagination || {
        pageIndex: 0,
        pageSize: 10,
        total: 0,
        totalPages: 0,
      };
      return {
        ...state,
        employeeTransferRequests: list,
        employeeTransferRequestsCount: pagination.total || 0,
        employeeTransferRequestsPagination: pagination,
      };
    }
    case EmployeeActionTypes.Search_By_Name_Or_Id_Action:
      return {
        ...state,
        searchEmployeeList: action.payload,
      };
    default:
      return state;
  }
}
